import React from 'react';
import { Link } from 'gatsby';

import './Breadcrumbs.scss';

const Breadcrumbs = ({ children, breadcrumbs }) => {
  return (
    <div className="Breadcrumbs">
      <nav>
        <ul>
          {breadcrumbs?.map(({ link, label }) => (
            <li key={label}>{link ? <Link to={link}>{label}</Link> : <>{label}</>}</li>
          ))}
        </ul>
        {children}
      </nav>
    </div>
  );
};

export default Breadcrumbs;
